export const COMPANY_ID_LIST = 'zoneinfo';
export const SITE_ID_LIST = 'website';
export const COMPANY_NAME = 'profile';
export const COUNTRY = 'locale';
export const MIGRATION_VERSION = 'updated_at';
